import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import { useField } from "vee-validate";
import { ExclamationCircleIcon } from "@heroicons/vue/solid";
import BaseInput from "./_base.vue";

interface Props {
    name: string;
    locked?: boolean;
    multiple?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'file',
  props: {
    name: { type: String, required: true, default: undefined },
    locked: { type: Boolean, required: false, default: false },
    multiple: { type: Boolean, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const { value, errorMessage, meta, handleBlur, handleChange, validate } = useField<FileList>(props.name);

const hovering = ref(false);
const input = ref<HTMLInputElement>();

function dragover(event: Event) {
    event.preventDefault();
    hovering.value = true;
}

function dragleave(event: Event) {
    event.preventDefault();
    if (hovering.value) {
        hovering.value = false;
    }
}

function drop(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    const dragEvent = event as DragEvent;
    const files = dragEvent.dataTransfer?.files;
    if (!files || !files.length || !input.value) return;
    input.value.files = files;
    input.value.dispatchEvent(new Event("input"));
    hovering.value = false;
}

function removeFile(index: number) {
    if (input.value && input.value.files && input.value.files.length) {
        const dt = new DataTransfer();
        let i = 0;

        for (let file of input.value.files) {
            if (i !== index) dt.items.add(file);
            i++;
        }

        input.value.files = dt.files;

        input.value.dispatchEvent(new Event("input"));
    }
}

const message = computed(() => {
    switch (document.documentElement.lang) {
        case "fr":
            return '<span class="text-primary group-hover:no-underline underline">Sélectionnez des fichiers</span> ou déposez-les ici.';
        
        case "en":
            return '<span class="text-primary group-hover:no-underline underline">Select</span> or drag files here.';

        default:
            return '<span class="text-primary group-hover:no-underline underline">Kies bestanden</span> of sleep ze hiernaartoe.';
    }
});

const __returned__ = { props, value, errorMessage, meta, handleBlur, handleChange, validate, hovering, input, dragover, dragleave, drop, removeFile, message, get ExclamationCircleIcon() { return ExclamationCircleIcon }, BaseInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})